<template>
  <div class="container">
    <div class="row">
      <div class="col-10">
        <model-select
          v-model="value"
          :options="options"
          :placeholder="placeholder"
          @select="handleSelect"
        />
      </div>
      <div class="col-2">
        <button
          type="button"
          class="btn btn-outline-secondary"
          @click="reset"
        >
          Reset
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";

export default {
  name: "FilitableSelector",
  components: {
    ModelSelect,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    handleSelect: {
      type: Function,
      default: () => false,
    },
    placeholder: {
      type: String,
      default: "Select company",
    },
  },
  data() {
    return {
      options: Object.values(this.data).map((item) => ({
        value: item.id,
        text: item.name,
      })),
      value: null,
    };
  },
  watch: {
    value() {
      this.handleSelect(this.value);
    },
  },
  methods: {
    reset() {
      this.value = null;
    },
  },
};
</script>
